import { BaseMessageDOM } from './base-message-dom';

export class FixedMessageDOM extends BaseMessageDOM implements MessageDOM {
  public get isReady(): boolean {
    return this.buildDomComplete;
  }

  public show(): void {
    if (this.el == null) return;

    document.body.appendChild(this.el);
    // セッションの開始など、ページ表示直後に発火するイベントをトリガーとしてメッセージが表示される場合もある。
    // 画面がガチャガチャ動くのを防ぐために表示を1秒遅らせている。
    setTimeout(() => {
      this.el!.style.opacity = '1';
    }, 1000);
  }
}
